import type { StaffOrderCountData } from "../types";

interface Props {
  orderData?: StaffOrderCountData;
}

export function CountBar({ orderData }: Props) {
  const dataList = [
    { name: "新订单", count: orderData?.new_count ?? 0 },
    { name: "服务中", count: orderData?.service_count ?? 0 },
    { name: "已完成", count: orderData?.finish_count ?? 0 },
    { name: "超时服务", count: orderData?.over_count ?? 0 },
  ];

  return (
    <div className="flex items-center justify-around py-3">
      {dataList.map((item, i) => (
        <div key={i} className="flex flex-col items-center">
          <span className="text-lg font-bold text-white">{item.count}</span>
          <span className="text-sm mt-0.5" style={{ color: "rgba(255,255,255,0.7)" }}>{item.name}</span>
        </div>
      ))}
    </div>
  );
}
